import React from 'react';
import commonMethod from '../../lib/commonMethod';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import Light from '../../assets/img/device/light';
import MoodLight from '../../assets/img/device/moodLight';
import Aircon from '../../assets/img/device/aircon';
import DoorSensor from '../../assets/img/device/doorSensor';
import IndirectLight from '../../assets/img/device/indirectLight';
import MotionSensor from '../../assets/img/device/motionSensor';
import Switch1 from '../../assets/img/device/switch1';
import Switch2 from '../../assets/img/device/switch2';
import Switch3 from '../../assets/img/device/switch3';
import Switch4 from '../../assets/img/device/switch4';
import Switch5 from '../../assets/img/device/switch5';
import Switch6 from '../../assets/img/device/switch6';
import Zigbee1 from '../../assets/img/device/zigbee1';
import Zigbee2 from '../../assets/img/device/zigbee2';
import Zigbee3 from '../../assets/img/device/zigbee3';
import ThSensor from '../../assets/img/device/thSensor';
import IrTv from '../../assets/img/device/irTv';
import IrFan from '../../assets/img/device/fan';
import IrSettopbox from '../../assets/img/device/settopbox';
import Curtain from '../../assets/img/device/curtain';
import Airpurifier from '../../assets/img/device/airPurifier';
import Speaker from '../../assets/img/device/speaker';
import Projector from '../../assets/img/device/projector';
import Lamp from '../../assets/img/device/lamp';
import Dvd from '../../assets/img/device/dvd';
import Repeater from '../../assets/img/device/repeater';
import PowerIcon from '../../assets/img/dashboard/power';
import Plug from '../../assets/img/device/plug';
import Camera from '../../assets/img/device/camera';
import IrDIY from '../../assets/img/device/diy';
import Relay from '../../assets/img/device/relay';
import HomeCamera from '../../assets/img/device/homeCamera';
import HomeCameraPro from '../../assets/img/device/homeCameraPro';
import HomeCameraProPlus from '../../assets/img/device/homeCameraProPlus';
import DefaultIcon from '../../assets/img/device/default';
import DeviceType from './DeviceType';
import FourButton from '../../assets/img/device/fourButton';
import SmartTh from '../../assets/img/device/smartTh';
import Siren from '../../assets/img/device/siren';
import RadarSensor from '../../assets/img/device/radarSensor';
import SensorGas from '../../assets/img/device/sensorGas';
import PowerStrip from '../../assets/img/device/powerStrip';
import BruntPlug from '../../assets/img/device/bruntPlug';
import SmartDoorLock from '../../assets/img/device/smartDoorLock';
import SensorRefTh from '../../assets/img/device/sensorRefTh';
import StarProjector from '../../assets/img/device/starProjector';
import Blind from '../../assets/img/device/blind';
import SensorWater from '../../assets/img/device/sensorWater';
import SensorSmoke from '../../assets/img/device/sensorSmoke';
import RelayControllerDc from '../../assets/img/device/relayControllerDc';
class DeviceItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
      isOn: false,
      state: '',
      animation: false,
      off: false,
      item: this.props.item
    };
    this.accessToken = cookie.load('accessToken');
  }

  // 디바이스 제어 함수
  actionDevice(item) {
    let newItem = item;
    let url = 'dashboard/control/';

    if (
      item &&
      item.online &&
      item.deviceType !== 'SensorTh' &&
      item.deviceType !== 'SensorDo' &&
      item.deviceType !== 'SensorTh2'
    ) {
      let data = {
        requirments: {
          power: true
        }
      };

      if (item.deviceType.indexOf('Switch') !== -1) {
        // 스위치인 경우
        let isOn = false;
        for (let key in item.deviceState) {
          if (item.deviceState[key]) {
            isOn = true;
          }
        }
        let switchCount = Number(item.deviceType.split('Switch')[1]);
        let requirments = {};
        for (let i = 1; i < switchCount + 1; i++) {
          Object.assign(requirments, { ['power' + i]: !isOn });
        }
        data.requirments = requirments;
        newItem.deviceState = requirments;
      } else if (item.deviceType === 'IrAirconditioner') {
        // 에어컨인 경우
        if (item.deviceState && item.deviceState.power === '켜짐') {
          data.requirments = { power: 'false' };
          newItem.deviceState.power = '꺼짐';
        } else {
          data.requirments = { power: 'true' };
          newItem.deviceState.power = '켜짐';
        }
      } else if (item.deviceType.indexOf('Curtain') !== -1) {
        // 커튼인 경우
        if (item.deviceState && item.deviceState.control === 'open') {
          data.requirments = { control: 'close' };
          newItem.deviceState.control = 'close';
        } else {
          data.requirments = { control: 'open' };
          newItem.deviceState.control = 'open';
        }
      } else if (item.deviceState && item.deviceState.power === 'true') {
        data.requirments.power = 'false';
        newItem.deviceState.power = 'false';
      } else if (item.deviceState && item.deviceState.power === 'false') {
        data.requirments.power = 'true';
        newItem.deviceState.power = 'true';
      } else if (
        item.deviceState &&
        (item.deviceState.power === true ||
          item.deviceState.power === false ||
          item.deviceState.power === 'true' ||
          item.deviceState.power === 'false')
      ) {
        // on, off가 가능한 제품 상태 변경
        data.requirments.power = !item.deviceState.power;
        newItem.deviceState.power = !item.deviceState.power;
      } else if (
        item.deviceType.indexOf('Ir') !== -1 &&
        item.deviceType !== 'IrAirconditioner'
      ) {
        data.requirments = { power: true };
      } else if (item.deviceType.includes('RelayController')) {
        data.requirments = { power1: !item.deviceState.power1 };
        newItem.deviceState = { power1: !item.deviceState.power1 };
      } else if (item.deviceType.includes('PowerStrip')) {
        data.requirments = { power5: !item.deviceState.power5 };
        newItem.deviceState = { power5: !item.deviceState.power5 };
      }
      this.props.handleItemPower(item);
      this.setState({ item: item });
      if (this.props.demo === true) {
      } else {
        commonMethod.requestPostWithData(
          url + item.id,
          this.accessToken,
          JSON.stringify(data),
          this,
          res => {}
        );
      }
    }
  }

  getDeviceIcon(type) {
    // 디바이스 아이콘
    if (
      type === 'LightRgbw5' ||
      type === 'LightRgbw3' ||
      type === 'LightRgbw2' ||
      type === 'LightRgbw1' ||
      type === 'LightWw3' ||
      type === 'LightWw2' ||
      type === 'LightWw1'
    )
      return <Light />;
    else if (type === 'LightRgbw4') return <MoodLight />;
    else if (
      type === 'LedStripRgbw2' ||
      type === 'LedStripRgbw1' ||
      type === 'LedStripRgb'
    )
      return <IndirectLight />;
    else if (type === 'IrAirconditioner') return <Aircon />;
    else if (type === 'Switch1') return <Switch1 />;
    else if (type === 'Switch2') return <Switch2 />;
    else if (type === 'Switch3') return <Switch3 />;
    else if (type === 'Switch4') return <Switch4 />;
    else if (type === 'Switch5') return <Switch5 />;
    else if (type === 'Switch6') return <Switch6 />;
    else if (type === 'ZigbeeSwitch1') return <Zigbee1 />;
    else if (type === 'ZigbeeSwitch2') return <Zigbee2 />;
    else if (type === 'ZigbeeSwitch3') return <Zigbee3 />;
    else if (type === 'SensorDo') return <DoorSensor />;
    else if (type === 'SensorTh') return <ThSensor />;
    else if (type === 'SensorMo') return <MotionSensor />;
    else if (type === 'IrTv' || type === 'IrTvbox') return <IrTv />;
    else if (type === 'IrFan') return <IrFan />;
    else if (type === 'IrSettopbox') return <IrSettopbox />;
    else if (type === 'Curtain') return <Curtain />;
    else if (type === 'IrAirpurifer' || type === 'Airpurifier')
      return <Airpurifier />;
    else if (type === 'IrSpeaker') return <Speaker />;
    else if (type === 'IrProjector') return <Projector />;
    else if (type === 'IrLamp') return <Lamp />;
    else if (type === 'IrDvd') return <Dvd />;
    else if (type === 'IrRepeater') return <Repeater />;
    else if (type === 'Plug' || type === 'SmartPlug') return <Plug />;
    else if (type === 'IrCamera') return <Camera />;
    else if (type === 'IrDIY') return <IrDIY />;
    else if (type === 'Relay' || type === 'RelayController') return <Relay />;
    else if (type === 'HomeCamera') return <HomeCamera />;
    else if (type === 'HomeCameraPro') return <HomeCameraPro />;
    else if (type === 'HomeCameraProPlus') return <HomeCameraProPlus />;
    else if (type === 'SensorTh2') return <SmartTh />;
    else if (type === 'SensorRadar') return <RadarSensor />;
    else if (type === 'AudibleAlarm') return <Siren />;
    else if (type === 'SmartButton') return <FourButton />;
    else if (type.includes('SensorGas')) return <SensorGas />;
    else if (type.includes('PowerStrip')) return <PowerStrip />;
    else if (type.includes('BruntPlug')) return <BruntPlug />;
    else if (type.includes('SmartDoorLock')) return <SmartDoorLock />;
    else if (type.includes('ZigbeeDoorlock')) return <SmartDoorLock />;
    else if (type.includes('SensorRefTh')) return <SensorRefTh />;
    else if (type.includes('StarProjector')) return <StarProjector />;
    else if (type.includes('Blind')) return <Blind />;
    else if (type.includes('SensorWater')) return <SensorWater />;
    else if (type.includes('SensorSmoke')) return <SensorSmoke />;
    else if (type.includes('RelayControllerDc')) return <RelayControllerDc />;
    else return <DefaultIcon />;
  }

  togglePanel(e, item) {
    if (
      (!DeviceType.sensor.includes(item.deviceType) &&
        !DeviceType.alarm.includes(item.deviceType) &&
        !DeviceType.doorlock.includes(item.deviceType) &&
        item.online) ||
      item.deviceType === 'AudibleAlarm'
    ) {
      if (e.target.nodeName !== 'BUTTON') {
        this.props.handlePanelToggle(item);
      }
    }
  }

  convertTime(timestamp, type) {
    var date = new Date(timestamp);
    var year = date.getFullYear();
    var month = date.getMonth();
    month = month + 1;
    month =
      month.toString().length <= 1 ? '0' + month.toString() : month.toString();

    var day = date.getDate();
    day = day.toString().length <= 1 ? '0' + day.toString() : day.toString();

    var hours = date.getHours();
    hours =
      hours.toString().length <= 1 ? '0' + hours.toString() : hours.toString();

    var minutes = date.getMinutes();
    minutes =
      minutes.toString().length <= 1
        ? '0' + minutes.toString()
        : minutes.toString();

    // Will display time in 10:30:23 format
    var formattedDate =
      year.toString().substr(-2) + '.' + month + '.' + day + '.';
    var formattedTime = hours + ':' + minutes.substr(-2);

    if (type === 'date') {
      return formattedDate;
    } else {
      return formattedTime;
    }
  }

  actionIrDevice(item) {
    const data = {
      requirments: {
        power: true
      }
    };

    if (!this.props.demo) {
      commonMethod.requestPostWithData(
        'dashboard/control/' + item.id,
        this.accessToken,
        JSON.stringify(data),
        this,
        res => {}
      );
    }

    this.setState({ animation: true });
    setTimeout(() => {
      this.setState({ animation: false });
    }, 500);
  }

  getClassName(item) {
    // 클릭 후 애니메이션
    if (item.deviceState === null && item.deviceType.indexOf('Ir') !== 1) {
      if (item.online) {
        if (this.state.animation) {
          return 'device-item no-off active';
        } else {
          return 'device-item';
        }
      } else {
        return 'device-item off offline';
      }
    } else if (item.online) {
      if (
        item.deviceType.indexOf('Switch') !== -1 ||
        item.deviceType.indexOf('PowerStrip') !== -1 ||
        item.deviceType.indexOf('PowerStrip2') !== -1
      ) {
        // 스위치인 경우 스위치 갯수만큼 on/off 체크
        let isOn = false;
        for (var key in item.deviceState) {
          if (item.deviceState[key]) {
            isOn = true;
          }
        }
        if (!isOn) {
          return 'device-item off';
        } else {
          return 'device-item';
        }
      } else if (
        item.deviceState.power === false ||
        item.deviceState.power === '꺼짐' ||
        item.deviceState.power1 === false ||
        item.deviceState.power === 'false'
      ) {
        return 'device-item off';
      } else {
        return 'device-item';
      }
    } else {
      return 'off offline';
    }
  }

  getColorClassName() {
    const { result, panelToggle } = this.props;
    let className = '';
    if (result && panelToggle) {
      className = 'borderColor';
    }

    return className;
  }

  render() {
    let { item } = this.state;

    return (
      <li
        className={this.getClassName(item) + ' ' + this.getColorClassName()}
        onClick={e => this.togglePanel(e, item)}
        tabIndex="1"
      >
        <div className={`overlay`} />
        <p className="device-image">{this.getDeviceIcon(item.deviceType)}</p>
        <div className="info">
          <div className="top">
            <h4>{item.name}</h4>
            <span
              className="family-name"
              title={
                this.props.familyName.length > 4 ? this.props.familyName : ''
              }
            >
              {this.props.familyName}
            </span>
            <span className="bar"> / </span>
            <span
              className="room-name"
              title={this.props.roomName.length > 4 ? this.props.roomName : ''}
            >
              {this.props.roomName}
            </span>
          </div>
          {/* 전원 */}
          {item.deviceState &&
            !DeviceType.powerStrip.includes(item.deviceType) &&
            (item.deviceState.hasOwnProperty('power') ||
              item.deviceState.hasOwnProperty('power1')) &&
            !DeviceType.sensor.includes(item.deviceType) && (
              <button onClick={() => this.actionDevice(item)}>
                <PowerIcon />
                전원
              </button>
            )}
          {item.deviceState && DeviceType.powerStrip.includes(item.deviceType) && (
            <button onClick={() => this.actionDevice(item)}>
              <PowerIcon />
              전원
            </button>
          )}
          {/* 온도 */}
          {DeviceType.temp.includes(item.deviceType) && (
            <p className="button-flex">
              <strong>{item.deviceState.temperature}&#8451;</strong>
              <strong>
                {item.deviceState.content
                  ? item.deviceState.content
                  : item.deviceState.humidity}
                %
              </strong>
            </p>
          )}
          {/* 날짜 */}
          {DeviceType.date.includes(item.deviceType) &&
            item.deviceState.hasOwnProperty('t') && (
              <p className="button date-button">
                <strong>{this.convertTime(item.deviceState.t, 'date')}</strong>
                <strong>{this.convertTime(item.deviceState.t, 'time')}</strong>
              </p>
            )}
          {DeviceType.alarm.includes(item.deviceType) && (
            <p className="button">
              {item.deviceState.alarm === true ? '감지됨' : '감지안됨'}
            </p>
          )}
          {item.deviceType === 'AudibleAlarm' && (
            <p className="button">
              {item.deviceState.alarmSwitch === true ? '감지됨' : '감지안됨'}
            </p>
          )}
          {/* 열림 / 닫힘 */}
          {DeviceType.openClose.includes(item.deviceType) && (
            <p className="button">
              {item.deviceState.state === 'CLOSED' ? '닫힘' : '열림'}
            </p>
          )}
          {DeviceType.blind.includes(item.deviceType) && (
            <p className="button">
              {item.deviceState.percentControl !== undefined
                ? Number(item.deviceState.percentControl) > 0
                  ? '열림'
                  : '닫힘'
                : Number(item.deviceState.percentState) > 0
                ? '열림'
                : '닫힘'}
            </p>
          )}
          {item.deviceType === 'ZigbeeDoorlock' && (
            <p className="button">
              {item.deviceState.doorOpened === false ? '닫힘' : '열림'}
            </p>
          )}
          {this.props.demo
            ? item.deviceType === 'Curtain' &&
              (item.deviceState.control === 'close' ? (
                <p className="button">
                  {item.deviceState.percentControl === 0 ? '닫힘' : '열림'}
                </p>
              ) : (
                <p className="button">
                  {item.deviceState.percentControl === 0 ? '닫힘' : '열림'}
                </p>
              ))
            : item.deviceType === 'Curtain' && (
                <p className="button">
                  {item.deviceState.percentState === 0 ||
                  item.deviceState.percentState === '0'
                    ? '닫힘'
                    : '열림'}
                </p>
              )}
          {item.deviceType.includes('Ir') && item.deviceState === null && (
            <button onClick={() => this.actionIrDevice(item)}>
              <PowerIcon />
              전원
            </button>
          )}
        </div>
        {!item.online && <p className="offline-text">오프라인</p>}
      </li>
    );
  }
}

function mapStateToProps(state) {
  return {
    accessToken: state.hejhome.accessToken
  };
}

// dispatch - set
const mapDispatchToProps = dispatch => ({
  setAccessToken: token =>
    dispatch({
      type: 'setAccessToken',
      accessToken: token
    })
});

DeviceItem = connect(mapStateToProps, mapDispatchToProps)(DeviceItem);

export default DeviceItem;
